function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.724 56.724",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M7.487,46.862c1.111,1.467,2.865,2.275,4.938,2.275h30.598c3.984,0,7.934-3.009,8.991-6.849 l4.446-16.136c0.55-1.997,0.237-3.904-0.88-5.371c-1.118-1.467-2.873-2.274-4.945-2.274h-3.044l-0.667-2.65 c-0.692-2.759-4.368-4.919-8.367-4.919h-11.24c-2.932,0-4.935-0.6-5.413-0.94c-1.259-2.292-6.867-2.41-8-2.41h-7.27 c-2.036,0-3.845,0.798-5.093,2.249c-1.248,1.45-1.769,3.356-1.448,5.467l6.338,29.047C6.572,45.268,6.926,46.122,7.487,46.862z  M53.193,22.599c0.537,0.705,0.669,1.684,0.374,2.756l-4.445,16.137c-0.693,2.518-3.486,4.646-6.099,4.646H12.425 c-1.112,0-2.016-0.386-2.547-1.086c-0.531-0.701-0.657-1.676-0.356-2.746l3.057-10.858c0.709-2.518,3.518-4.646,6.133-4.646h9.751 c3.51,0,7.461-1.271,8.219-3.695c0.196-0.479,2.256-1.6,5.359-1.6h8.593C51.749,21.507,52.657,21.895,53.193,22.599z M3.815,11.792 c0.669-0.777,1.671-1.206,2.82-1.206h7.27c2.932,0,4.935,0.6,5.413,0.941c1.26,2.292,6.866,2.41,7.999,2.41h11.241 c2.743,0,5.144,1.399,5.458,2.65l0.482,1.919h-2.456c-3.511,0-7.461,1.271-8.219,3.695c-0.197,0.479-2.257,1.6-5.359,1.6h-9.751 c-3.979,0-7.942,3.001-9.021,6.832l-1.793,6.371L3.042,14.758C2.871,13.623,3.146,12.569,3.815,11.792z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/emptyIcon.1631850137dce8df2ccc718c687df979.svg";
export { ForwardRef as ReactComponent };